import { render, staticRenderFns } from "./ShopcardBundleProductPaymentShow.vue?vue&type=template&id=580d8a2d"
import script from "./ShopcardBundleProductPaymentShow.vue?vue&type=script&lang=js"
export * from "./ShopcardBundleProductPaymentShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports